export default "__VITE_ASSET__DL3HzH6Q__"